// btw-front/src/api/notices.js
import { api, getAccessToken } from "./client";

// 목록 — 관리자: 전체(status 필터 가능) / 파트너: published 만(서버 강제)
export async function list({ status, q } = {}) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (q) params.set("q", q);
  const qs = params.toString();
  return api.get(`/notices${qs ? `?${qs}` : ""}`);
}

export async function get(id) {
  return api.get(`/notices/${encodeURIComponent(id)}`);
}

// 대시보드 메인 공지 1건(발행글 한정). 없으면 null.
export async function featured() {
  return api.get(`/notices/featured`);
}

export async function create(payload) {
  return api.post(`/notices`, payload);
}

export async function update(id, payload) {
  return api.put(`/notices/${encodeURIComponent(id)}`, payload);
}

export async function remove(id) {
  return api.del(`/notices/${encodeURIComponent(id)}`);
}

// 첨부 업로드 — File[] 다중. FormData 'attachments' 필드에 모두 append.
export async function uploadAttachments(id, files) {
  const fd = new FormData();
  Array.from(files || []).forEach((f) => fd.append("attachments", f, f.name));
  return api.postForm(`/notices/${encodeURIComponent(id)}/attachments`, fd);
}

export async function removeAttachment(id, attId) {
  return api.del(`/notices/${encodeURIComponent(id)}/attachments/${encodeURIComponent(attId)}`);
}

// 첨부 다운로드 — Authorization 헤더 필요해 fetch 직접 사용 후 Blob 처리(견적서 패턴 동일)
export async function downloadAttachment(id, attId, suggestedName) {
  const token = getAccessToken();
  const res = await fetch(
    `/api/notices/${encodeURIComponent(id)}/attachments/${encodeURIComponent(attId)}`,
    { headers: token ? { Authorization: `Bearer ${token}` } : {} },
  );
  if (!res.ok) {
    let msg = "Download failed";
    try {
      const j = await res.json();
      msg = (j && j.error && j.error.message) || msg;
    } catch (e) {}
    throw new Error(msg);
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = suggestedName || "attachment";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 500);
}
